import { brand } from "../brand";
import { BETA_NOTICE, TERMS_VERSION } from "./legal";

export function Rights() {
  return (
    <main className="narrow prose legal">
      <p className="muted">{BETA_NOTICE}</p>
      <h1>For rights holders</h1>
      <p>
        {brand.name} lets a student upload a textbook or past paper they already have and makes
        private study material from it. The book is an input, never an output: it is not shown,
        shared, offered for download, or reused for anyone else. Each account&rsquo;s material is
        made from that account&rsquo;s own copy alone, and no account can ever see another&rsquo;s.
      </p>
      <h2>Sending a notice</h2>
      <p>
        Write to {brand.supportEmail} with the title and ISBN of the work, what you believe has been
        uploaded, and how we can reach you. You do not need to identify the account.
      </p>
      <h2>What happens</h2>
      <ol>
        <li>
          Within one working day the upload is marked <strong>withdrawn</strong>: the material made
          from it is removed from the account at once.
        </li>
        <li>We reply to you with what was done.</li>
        <li>Unless the matter is resolved, the upload itself is deleted after 14 days.</li>
      </ol>
      <p>
        Because every upload is fingerprinted at arrival, &ldquo;every copy of this file&rdquo; can
        be answered across all accounts without any account having seen another&rsquo;s content.
      </p>
      <p className="muted">Version {TERMS_VERSION}.</p>
    </main>
  );
}
